import { datadogRum } from '@datadog/browser-rum'
import { Component, ErrorInfo, ReactNode } from 'react'
import { CustomErrorBoundary } from './CustomErrorBoundary'

type Props = { children: ReactNode }
type State = { error: unknown; hasError: boolean }

export class ReactErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null }
  static getDerivedStateFromError(error: unknown): State {
    return { hasError: true, error }
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    datadogRum.addError(error, { componentStack: info.componentStack })
  }
  render() {
    if (this.state.hasError) return <CustomErrorBoundary errorData={{ error: this.state.error }} />
    return this.props.children
  }
}
